import common from "./endpoints/common"
import doctor from "./endpoints/doctor"
import patients from "./endpoints/patients"
import endpointStatic from "./endpoints/static"

export default {
	common,
	static: endpointStatic,
	doctor,
	patients
}
